/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* Generated TypeScript interfaces from Swagger specification
* Do not edit this file manually
*/
import { HttpContext, HttpHeaders } from "@angular/common/http";
export type AnimateImageRequest = ImageRequest & { width?: number; height?: number; backgroundColor?: string; loopCount?: number; frameOptions?: Array<AnimationFrameOptions> };

export interface AnimationFrameOptions {
    index?: number;
    time?: number;
}

export interface ImageRequest {
    /** Gets or sets desired image format. */
    toFormat?: string | null;
    /** Gets or sets list of Base64 encoded images. */
    imageBase64Files?: Array<string>;
}

/** Response returned when an asynchronous image operation is enqueued. */
export interface EnqueueImageOperationResponse {
    /** Gets or sets the operation identifier to pass to GET /async/get-status. */
    operationId?: string;
}

/** Status of an asynchronous image operation. */
export interface AsyncOperationStatusResponse {
    /** Gets or sets the operation identifier returned when the async request was enqueued. */
    operationId?: string;
    /** Gets or sets completion percentage from 0 to 100. */
    progress?: number;
    /** Gets or sets current lifecycle state of the operation. */
    state?: OperationState;
    /** Gets or sets operation result when completed. For file results this is a download URL; for errors, the error message. */
    result?: string | null;
}

export enum OperationState {
    Pending = 0,
    Starting = 1,
    InProgress = 2,
    Completed = 3,
    Error = 4,
    Cancelled = 5
}

export interface ProblemDetails {
    type?: string | null;
    title?: string | null;
    status?: number | null;
    detail?: string | null;
    instance?: string | null;
    extensions?: Record<string, any>;
}

export type CompressImageRequest = ImageRequest & { calculateQualityLoss?: boolean };
export type CropImageRequest = ImageRequest & { cropAreaOptions?: Array<CropAreaOptions> };

export interface CropAreaOptions {
    pageIndex?: number;
    cornerRadius?: number;
    cropArea?: Array<Point>;
}

export interface Point {
    x?: number;
    y?: number;
}

export type DeskewImageRequest = ImageRequest & { deskewImagePageOptions?: Array<DeskewImagePageOptions> };

export interface DeskewImagePageOptions {
    pageIndex?: number | null;
    resizeProportionally?: boolean | null;
    backgroundColor?: string | null;
}

export type SkewAngleImageRequest = ImageRequest & { pageIndex?: number | null };
export type EditImageRequest = ImageRequest & { edits?: Array<ImageRequest> };
export type FilterEffectImageRequest = ImageRequest & { effect?: FilterEffect; size?: number | null; sigma?: number | null; angle?: number | null };

export enum FilterEffect {
    BigRectangular = 0,
    SmallRectangular = 1,
    Median = 2,
    GaussWiener = 3,
    MotionWiener = 4,
    GaussianBlur = 5,
    Sharpen = 6,
    BilateralSmoothing = 7
}

export type FlipRotateImageRequest = ImageRequest & { angle?: number; rotateFlipType?: RotateFlipType; backgroundColor?: string; resizeProportionally?: boolean };

export enum RotateFlipType {
    RotateNoneFlipNone = 0,
    Rotate90FlipNone = 1,
    Rotate180FlipNone = 2,
    Rotate270FlipNone = 3,
    RotateNoneFlipX = 4,
    Rotate90FlipX = 5,
    Rotate180FlipX = 6,
    Rotate270FlipX = 7,
    RotateNoneFlipY = 8,
    Rotate90FlipY = 9,
    Rotate180FlipY = 10,
    Rotate270FlipY = 11,
    RotateNoneFlipXY = 12,
    Rotate90FlipXY = 13,
    Rotate180FlipXY = 14,
    Rotate270FlipXY = 15
}

export interface UploadImageResponse {
    fileId?: string;
    expiresAt?: string;
    previewContentType?: string | null;
    previewBytes?: string | null;
}

export interface UploadImageRequest {
    previewImageWidth?: number | null;
    imageFileAsBase64?: string;
}

export type MergeImageRequest = MergeImageRequestBase & { imageLayoutOptions?: Array<MergeImageLayoutOptions> };

export interface MergeImageLayoutOptions {
    bounds?: Rectangle;
    backgroundColor?: string | null;
    borderColor?: string | null;
    margin?: Margin;
    borderWidth?: number;
    imageIndex?: number | null;
}

export type Rectangle = Size & { x?: number; y?: number };

export interface Size {
    width?: number;
    height?: number;
}

export interface Margin {
    top?: number;
    left?: number;
    right?: number;
    bottom?: number;
}

export type MergeImageRequestBase = ImageRequest & { backgroundColor?: string | null; margin?: Margin; borderWidth?: number | null; borderColor?: string | null; commonSize?: Area };

export interface Area {
    width?: number;
    height?: number;
    top?: number;
    left?: number;
}

export type GridMergeImageRequest = MergeImageRequestBase & { columnCount?: number; rowCount?: number };
export type FlexMergeImageRequest = MergeImageRequestBase & { orientation?: Orientation };

export enum Orientation {
    Vertical = 0,
    Horizontal = 1
}

export interface ObjectDetectionBounds {
    pages?: Array<Page>;
}

export interface Page {
    number?: number;
    detectedObjects?: Array<DetectedObject>;
}

export interface DetectedObject {
    label?: string;
    score?: number;
    bounds?: Rectangle2;
}

export type Rectangle2 = Size2 & { x?: number; y?: number };

export interface Size2 {
    width?: number;
    height?: number;
}

export type ObjectDetectionImageRequest = ImageRequest & { probabilityThreshold?: number; pageNumbers?: Array<number> };
export type DrawDetectedObjectsBoundsImageRequest = ObjectDetectionImageRequest & { color?: string | null; includeLabel?: boolean; includeScore?: boolean; allowedLabels?: Array<string>; blockedLabels?: Array<string> };
export type RemoveBackgroundImageRequest = ImageRequest & { featheringRadius?: number | null; backgroundColor?: string | null; pageIndex?: number | null; assumedObjects?: Array<AssumedObject>; precalculateMarkers?: boolean | null };

export interface AssumedObject {
    bounds?: Rectangle2;
    label?: string;
    score?: number;
}

export type ResizeImageRequest = ImageRequest & { sizePercentage?: number | null; width?: number | null; height?: number | null; keepAspectRatio?: boolean; backgroundColor?: string | null; resizeType?: ResizeType };

export enum ResizeType {
    None = 0,
    LeftTopToLeftTop = 1,
    RightTopToRightTop = 2,
    RightBottomToRightBottom = 3,
    LeftBottomToLeftBottom = 4,
    CenterToCenter = 5,
    LanczosResample = 6,
    NearestNeighbourResample = 7,
    AdaptiveResample = 8,
    BilinearResample = 9,
    HighQualityResample = 10,
    CatmullRom = 11,
    CubicConvolution = 12,
    CubicBSpline = 13,
    Mitchell = 14,
    SinC = 15,
    Bell = 16
}

export type SplitImageRequest = ImageRequest & { tiles?: Array<Rectangle> };
export type SplitByGridImageRequest = ImageRequest & { rowsCount?: number | null; columnsCount?: number | null; tileHeight?: number | null; tileWidth?: number | null };

export interface VisionObjectDetectionResponse {
    objects: Array<VisionDetectedObject>;
}

export interface VisionDetectedObject {
    /** Object name in English, as returned by the detector. */
    label: string;
    /** Object location as x, y, width, height in normalized 0..1000 image coordinates. */
    bounds: Rectangle2;
}

export interface VisionObjectDetectionRequest {
    /** Raw Base64 of one static PNG representing the current editor image. */
    imageBase64: string;
}

export type WatermarkImageRequest = ImageRequest & { watermarkText?: string; textColor?: string | null; fontName?: string | null; fontSize?: number | null; rotationAngleDegrees?: number | null };

/** Request Options for Angular HttpClient requests */
export interface RequestOptions<TResponseType extends 'arraybuffer' | 'blob' | 'json' | 'text'> {
    headers?: HttpHeaders;
    reportProgress?: boolean;
    responseType?: TResponseType;
    withCredentials?: boolean;
    context?: HttpContext;
}
